import PropTypes from 'prop-types';
import { find, identity, mapValues } from 'lodash';

export { dateFormat, parseDate, formatDate } from '../common';

export const mapModelOptions = (models, textKey) =>
  models.map(({ id, primaryKey, [textKey]: text }) => ({
    key: id,
    value:
      typeof primaryKey === 'string' ? primaryKey : JSON.stringify(primaryKey),
    text,
  }));

const defaultOptions = { complexPrimaryKey: false, multiple: false };

const mapModelValue = (value, transform, options = {}) => {
  const { complexPrimaryKey, multiple } = { ...defaultOptions, ...options };
  const $transform = complexPrimaryKey ? transform : identity;
  return multiple ? value.map($transform) : $transform(value);
};

export const serializeModelValue = (value, options) =>
  mapModelValue(value, JSON.stringify, options);

export const createOnModelChange = (onChange, options = {}) => (
  event,
  { value, ...rest },
) =>
  onChange(event, {
    value: mapModelValue(value, JSON.parse, options),
    ...rest,
  });

const serializeValue = value => {
  switch (typeof value) {
    case 'object':
      return JSON.stringify(value);
    default:
      return value;
  }
};

const parseValue = value => {
  switch (typeof value) {
    case 'string':
      if (!value.length) return undefined;
      return value.startsWith('[') ? JSON.parse(value) : value;
    default:
      return value;
  }
};

export const createOrmActions = (actions, rows) => ({
  create: values => actions.create({ ...values }),
  update: (key, values) =>
    actions.update(find(rows, { key }).primaryKey, values),
  destroy: key => actions.destroy(find(rows, { key }).primaryKey),
  export: selectedRows =>
    selectedRows.map(row => mapValues(row.currentValues, serializeValue)),
  import: records =>
    records.map(record => actions.upsert(mapValues(record, parseValue))),
});

export const formPropTypes = {
  formProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }).isRequired,
  values: PropTypes.object.isRequired,
  meta: PropTypes.object,
  onInputChange: PropTypes.func.isRequired,
};

export const editorPropTypes = {
  id: PropTypes.string.isRequired,
  meta: PropTypes.object,
  actions: PropTypes.shape({
    create: PropTypes.func,
    update: PropTypes.func,
    destroy: PropTypes.func,
  }).isRequired,
};

export const colorByGender = gender =>
  gender ? (gender.letter === 'W' ? 'pink' : 'blue') : undefined;



// WEBPACK FOOTER //
// ./src/components/common.js